import React from "react";

const CareWatchPageTitle = () => (
  <span className="care-watch-title-row">
    <span className="care-watch-title">Care Watch</span>
    <span className="care-watch-live">
      <span className="care-watch-live-pulse" aria-hidden="true">
        <span className="care-watch-live-ring care-watch-live-ring-outer" />
        <span className="care-watch-live-ring care-watch-live-ring-mid" />
        <span className="care-watch-live-dot" />
      </span>
      <span className="care-watch-live-label">Live</span>
    </span>
  </span>
);

export default CareWatchPageTitle;
